import { HashLink } from './HashLink';
import { mediaUrl } from '../services/api';
import { useLanguage } from '../i18n/LanguageContext';
import { Statistic } from '../types/content';

type HeroSectionProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  imageUrl?: string;
  stats?: Statistic[];
  ctaText?: string;
  ctaLink?: string;
  pillars?: string[];
  variant?: 'default' | 'home-split';
};

export function HeroSection({
  eyebrow,
  title,
  subtitle,
  imageUrl,
  stats,
  ctaText,
  ctaLink,
  pillars,
  variant = 'default',
}: HeroSectionProps) {
  const { t } = useLanguage();
  const bg = mediaUrl(imageUrl);
  // Banner yuksekligi website.css'teki ortak kuraldan gelir, satir ici stil verilmez.
  return (
    <section className={`hero ${variant === 'home-split' ? 'hero-home-split' : ''}`}>
      {bg && <div className="bg" style={{ backgroundImage: `url('${bg}')` }} />}
      <div className="overlay" />
      <div className="container hero-inner">
        {eyebrow && <div className="eyebrow">{t(eyebrow)}</div>}
        <h1 dangerouslySetInnerHTML={{ __html: t(title) }} />
        {subtitle && <p className="lead">{t(subtitle)}</p>}

        {pillars && pillars.length > 0 && (
          <div className="pillars">
            {pillars.map((p) => (
              <span className="pillar-pill" key={p}>
                {t(p)}
              </span>
            ))}
          </div>
        )}

        {stats && stats.length > 0 && (
          <div className="hero-stats">
            {stats.map((s) => (
              <div key={s.id}>
                <b>{s.value}</b>
                <span>{t(s.label)}</span>
              </div>
            ))}
          </div>
        )}

        {ctaText && ctaLink && (
          <HashLink to={ctaLink} className="btn btn-red">
            {t(ctaText)}
          </HashLink>
        )}
      </div>
    </section>
  );
}
